import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Globe } from "lucide-react";
import { toast } from "sonner";
import GoogleButton from "@/components/GoogleButton";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", company_name: "", country: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await register(form);
      toast.success("Account created!");
      nav("/dashboard");
    } catch (e2) {
      setErr(formatApiError(e2.response?.data?.detail) || e2.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-12 grid-bg" data-testid="register-page">
      <form onSubmit={submit} className="card-surface rounded-xl p-8 w-full max-w-md">
        <div className="flex items-center gap-2 mb-2">
          <Globe className="w-6 h-6 text-[#00F0FF]" />
          <span className="font-display font-extrabold text-lg">Create company account</span>
        </div>
        <p className="text-sm text-[#94A3B8] mb-6">List tools, post jobs and manage your presence.</p>
        {err && <div className="mb-4 text-sm text-[#EF4444] bg-[#EF4444]/10 border border-[#EF4444]/30 rounded px-3 py-2" data-testid="register-error">{err}</div>}
        {[["name", "Your name", "text"], ["company_name", "Company name", "text"], ["country", "Country", "text"], ["email", "Email", "email"], ["password", "Password", "password"]].map(([k, label, type]) => (
          <div key={k} className="mb-4">
            <label className="block text-sm text-[#94A3B8] mb-1">{label}</label>
            <input data-testid={`register-${k}`} type={type} required={k !== "company_name" && k !== "country"} value={form[k]} onChange={set(k)}
              className="w-full bg-[#0B0F19] border border-white/10 rounded-md px-4 py-2.5 focus:border-[#00F0FF] focus:outline-none" />
          </div>
        ))}
        <button disabled={busy} data-testid="register-submit"
          className="w-full bg-[#00F0FF] text-[#04121a] font-semibold py-3 rounded-md hover:brightness-110 transition disabled:opacity-50">
          {busy ? "Creating…" : "Create account"}
        </button>
        <div className="flex items-center gap-3 my-4">
          <div className="flex-1 h-px bg-white/10" />
          <span className="text-xs text-[#94A3B8]">or</span>
          <div className="flex-1 h-px bg-white/10" />
        </div>
        <GoogleButton label="Sign up with Google" />
        <p className="mt-4 text-sm text-[#94A3B8] text-center">
          Already have an account? <Link to="/login" className="text-[#00F0FF]">Sign in</Link>
        </p>
      </form>
    </div>
  );
}
